import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import StoreLayout from "@/components/StoreLayout";
import Home from "@/pages/HomeReforged";
import Shop from "@/pages/Shop";
import Checkout from "@/pages/Checkout";
import Track from "@/pages/Track";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import Discord from "@/pages/admin/Discord";
import { AuthPage, Account } from "@/pages/AuthPages";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Listings from "@/pages/admin/Listings";
import Categories from "@/pages/admin/Categories";
import Orders from "@/pages/admin/Orders";
import { Requests, Users } from "@/pages/admin/RequestsUsers";
import { Settings, Command } from "@/pages/admin/SettingsCommand";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<StoreLayout />}>
              <Route index element={<Home />} />
              <Route path="shop" element={<Shop />} />
              <Route path="checkout" element={<Checkout />} />
              <Route path="track" element={<Track />} />
              <Route path="login" element={<AuthPage mode="login" />} />
              <Route path="register" element={<AuthPage mode="register" />} />
              <Route path="account" element={<Account />} />
              <Route path="payment/success" element={<PaymentSuccess />} />
              <Route path="payment/cancel" element={<PaymentCancel />} />
            </Route>
            <Route path="admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="listings" element={<Listings />} />
              <Route path="categories" element={<Categories />} />
              <Route path="orders" element={<Orders />} />
              <Route path="requests" element={<Requests />} />
              <Route path="users" element={<Users />} />
              <Route path="settings" element={<Settings />} />
              <Route path="discord" element={<Discord />} />
              <Route path="command" element={<Command />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#0a0a0a", border: "1px solid #ff2a55", color: "#fff", borderRadius: 0 } }} />
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
